import * as React from 'react'
function SvgFileDown() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.144 2.144A2.625 2.625 0 016 1.375h9c.166 0 .325.066.442.183l5 5a.625.625 0 01.183.442v13A2.625 2.625 0 0118 22.625H6A2.625 2.625 0 013.375 20V4c0-.696.277-1.364.769-1.856zM6 2.625h7.375V6A2.625 2.625 0 0016 8.625h3.375V20A1.375 1.375 0 0118 21.375H6A1.375 1.375 0 014.625 20V4A1.375 1.375 0 016 2.625zm10 4.75h3.375v-.116l-4.634-4.634h-.116V6A1.375 1.375 0 0016 7.375zm-4 4c.345 0 .625.28.625.625v4.491l1.933-1.933a.625.625 0 11.884.884l-3 3a.621.621 0 01-.681.136.621.621 0 01-.203-.136l-3-3a.625.625 0 11.884-.884l1.933 1.933V12c0-.345.28-.625.625-.625z"
        fill="currentColor"
      />
    </svg>
  )
}
export default SvgFileDown
